import { cn } from 'v5/platform/dom/cn';

export type EnterpriseWorkspaceIconProps = {
  name: string;
  iconUrl: string;
  className?: string;
};

export function EnterpriseWorkspaceIcon({
  name,
  iconUrl,
  className
}: EnterpriseWorkspaceIconProps) {
  const initials = name.substring(0, 2).toUpperCase();

  return (
    <div
      className={cn(
        'w-6 h-6 rounded-sm overflow-hidden flex items-center justify-center shrink-0',
        !iconUrl && 'bg-bg-subtle',
        className
      )}
    >
      {iconUrl ? (
        <img
          src={iconUrl}
          alt=""
          className="size-full object-cover rounded-sm"
        />
      ) : (
        <span className="text-[7pt] font-bold text-fg-muted">{initials}</span>
      )}
    </div>
  );
}
